import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRouting from "./core/routes/AppRouting";
import { Store } from "./core/redux/store";
import "./index.css";

const queryClient = new QueryClient();

export function App() {
  return (
    <Provider store={Store}>
      <QueryClientProvider client={queryClient}>
        <AppRouting />
      </QueryClientProvider>
    </Provider>
  );
}

export default App;